import { useMemo } from 'react';
import { BULK_GRANULAR_SLA_MANAGEMENT_PATH, GRANULAR_SLA_LANDING_PATH, R2F_THRESHOLD_CONFIG_PATH, BULK_R2F_THRESHOLD_CONFIG_PATH, CORA_PATH, SHIPMENT_HISTORY_PATH, TRB_PATH } from 'src/core/config/navigationRoutes';
import { useURLSiteParam } from 'src/core/hooks/UseURLSiteParam';
import { getGranularSLAPath } from 'src/utils/Routes';


interface ApplicationRouteUrls
{
    granularSLALanding: string;
    granularSLARoute: string | undefined;
    bulkGranularSLARoute: string;
    r2fThresholdRoute: string;
    bulkR2fThresholdRoute: string;
    coraRoute: string;
    trbRoute: string;
    shipmentHistoryRoute: string;
}

export function applicationNavigationRoutes(): ApplicationRouteUrls
{
    const siteId = useURLSiteParam();


    const granularSLALanding = siteId ? getGranularSLAPath(siteId) : GRANULAR_SLA_LANDING_PATH;
    const granularSLARoute = useMemo(
        () => (
            siteId ? getGranularSLAPath( siteId ) : getGranularSLAPath( 'OAK4' )
        )
        , [ siteId ] );

    const bulkGranularSLARoute = BULK_GRANULAR_SLA_MANAGEMENT_PATH;
    const r2fThresholdRoute = siteId ? `${R2F_THRESHOLD_CONFIG_PATH}/${siteId}` : R2F_THRESHOLD_CONFIG_PATH;
    const bulkR2fThresholdRoute = BULK_R2F_THRESHOLD_CONFIG_PATH;
    const coraRoute = CORA_PATH;
    const trbRoute = TRB_PATH;
    const shipmentHistoryRoute = SHIPMENT_HISTORY_PATH;

    return { granularSLALanding, granularSLARoute, bulkGranularSLARoute, r2fThresholdRoute, bulkR2fThresholdRoute, coraRoute, trbRoute, shipmentHistoryRoute };
}
